import axios from "@/plugins/axios";
import { shortcuts } from "@/utils/defaultShortcuts";

export const state = () => ({
  shortcuts: {},
  pos_setting: {},
});

export const mutations = {
  SET_SHORTCUTS(state, payload) {
    state.shortcuts = payload;
  },
  SET_POS_SETTING(state, payload) {
    state.pos_setting = payload;
  },
};

export const actions = {
  initialState({ commit }) {
    commit("SET_SHORTCUTS", Object.assign({}, shortcuts));
  },

  async FetchAllShortCuts({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("pos/shortcuts")
        .then((res) => {
          commit("SET_SHORTCUTS", res.data.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  async FetchPosConfigurations({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("settings/pos-configuration/1")
        .then((res) => {
          commit("SET_POS_SETTING", res.data.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export const getters = {
  GetShortCuts: (state) => state.shortcuts,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
